import * as React from "react";
import { useSearchParams } from "react-router-dom";
import AuthPageWrapper from "../components/auth-page-wrapper";
import CompleteSignUp from "./complete-sign-up";
import SignUpProspect from "./sign-up-prospect";

const videoUrl = "http://ghostnews.ai/wp-content/uploads/2025/05/output-1.mp4";

/**
 * ====================================================================================================
 * REGISTRATION FLOW
 * ====================================================================================================
 *
 * The SignUp component (this file) conditionally renders one of two registration components
 * based on the presence of a token in the URL query parameters.
 *
 * The registration process is split into two separate steps, each handled by a different component:
 *
 * 1. SignUpProspect
 *    - Displayed when no token is present in the URL
 *    - Collects the user's email address
 *    - Calls the API endpoint: POST /onboarding/register
 *    - After successful submission, a verification email is sent to the user
 *
 * 2. CompleteSignUp
 *    - Displayed when a token is present in the URL e.g: /sign-up?token=eyJhbG... (from email verification link)
 *    - Collects company details and user details (first name, last name, password, etc...).
 *    - Calls the API endpoint: POST /onboarding/create-account (token is passed in the Authorization header: Bearer {token})
 *    - After successful submission, the user's account is created and a company entity is created
 *    - This user who initiated the registration process is assigned as the company admin
 *
 * ====================================================================================================
 */
const SignUp: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <AuthPageWrapper
      title="Sign up today to get into the newsroom"
      subtitle="Be part of the future of news."
    >
      {token ? <CompleteSignUp token={token} /> : <SignUpProspect />}
    </AuthPageWrapper>
  );
};

export default SignUp;
